import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { SyntheticEvent } from 'react';
import styled from '@emotion/styled';
import Link from 'presentations/views/components/atoms/Link';
import {
  borderRadius,
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';
import { black, primary, whiteFix } from 'presentations/views/styles/color';
import { aboutPath } from 'presentations/routes/path';
import * as tracker from 'presentations/views/helpers/analytics';
import Image from 'presentations/views/components/atoms/Image';
import { imagePath } from 'presentations/assets';

export default function () {
  const t = translateInComponent(translations);
  const onClick = (e: SyntheticEvent<HTMLDivElement>) => {
    e.preventDefault();
    tracker.setEvent('click job banner', {
      position: 'sub_top',
    });
    window.location.href = aboutPath();
  };

  return (
    <JobBanner
      href={aboutPath()}
      image={imagePath('pages/about/hiring_banner.jpg')}
      onClick={onClick}
    >
      <JobBannerHeader>
        <Image
          src={'logo/logo_jicoo-whB.svg'}
          alt={t('Jicoo')}
          width={80}
          height={20}
        />
      </JobBannerHeader>
      <JobBannerContent>
        <JobBannerContentText>{t(`job_text.0`)}</JobBannerContentText>
        <JobBannerContentText>{t(`job_text.1`)}</JobBannerContentText>
      </JobBannerContent>
      <JobBannerFooter>
        <JobBannerFooterTitle>{t(`job title`)}</JobBannerFooterTitle>
        <JobBannerFooterButton>{t('job button title')}</JobBannerFooterButton>
      </JobBannerFooter>
    </JobBanner>
  );
}

const JobBanner = styled(Link)<{ image: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 276px;
  height: 240px;
  color: ${black};
  background-image: url(${(props) => props.image});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  ${mediaMax.tablet} {
    width: 100%;
  }
`;
const JobBannerHeader = styled.div`
  padding: ${spacing(8)};
`;
const JobBannerContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  font-size: 15px;
  font-weight: ${fontWeight('bold')};
  text-align: center;
  padding-bottom: ${spacing(8)};
  color: ${whiteFix};
`;
const JobBannerContentText = styled.div`
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
`;
const JobBannerFooter = styled.div`
  background-color: ${primary};
  display: flex;
  justify-content: space-between;
  padding: ${spacing(8)} ${spacing(8)};
`;
const JobBannerFooterTitle = styled.div`
  font-size: 19px;
  font-weight: ${fontWeight('bold')};
  color: ${whiteFix};
`;
const JobBannerFooterButton = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${whiteFix};
  padding: 0 ${spacing(8)};
  line-height: 1;
  font-size: ${fontSize(12)};
  font-weight: ${fontWeight('bold')};
  border-radius: ${borderRadius(6)};
  color: ${whiteFix};
`;
